var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1866",
    "data-name": "Group 1866",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.188,
    height: 20.576,
    viewBox: "0 0 18.188 20.576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M27.792,37.595H26.345a3.434,3.434,0,0,0-6.66,0H11.35a.85.85,0,0,0,0,1.7h8.359a3.419,3.419,0,0,0,6.637,0h1.447a.834.834,0,0,0,.85-.85A.848.848,0,0,0,27.792,37.595Zm-4.777,2.894a2.044,2.044,0,1,1,2.044-2.044A2.048,2.048,0,0,1,23.016,40.489Z",
    transform: "translate(-10.477 -28.157)",
    fill: "#484848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M11.35,9.494h1.516a3.434,3.434,0,0,0,6.66,0h8.29a.85.85,0,0,0,0-1.7H19.5A3.472,3.472,0,0,0,16.172,5.2a3.4,3.4,0,0,0-3.307,2.595H11.35a.834.834,0,0,0-.85.85A.848.848,0,0,0,11.35,9.494ZM16.172,6.6a2.044,2.044,0,1,1-2.044,2.044A2.048,2.048,0,0,1,16.172,6.6Z",
    transform: "translate(-10.477 -5.2)",
    fill: "#484848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M27.715,67.395h-8.29a3.434,3.434,0,0,0-6.66,0H11.25a.85.85,0,0,0,0,1.7h1.516a3.434,3.434,0,0,0,6.66,0h8.29a.834.834,0,0,0,.85-.85A.848.848,0,0,0,27.715,67.395ZM16.1,70.289a2.044,2.044,0,1,1,2.044-2.044A2.048,2.048,0,0,1,16.1,70.289Z",
    transform: "translate(-10.4 -51.113)",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSearch);
export default __webpack_public_path__ + "static/media/filter-search.269b66411f982432987152a7a6f0868d.svg";
export { ForwardRef as ReactComponent };